import { render, staticRenderFns } from "./FUniswapRemoveLiquidity.vue?vue&type=template&id=890dc5d2&"
import script from "./FUniswapRemoveLiquidity.vue?vue&type=script&lang=js&"
export * from "./FUniswapRemoveLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./FUniswapRemoveLiquidity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports